// Allowed characters for license number fields: letters, digits, spaces,
// hyphens, and periods (some jurisdictions embed a period, e.g. Nevada's
// "S.0191355" format).
export const LICENSE_NUMBER_PATTERN = /^[A-Za-z0-9 .-]*$/;

export const LICENSE_NUMBER_ERROR_MESSAGE =
  'Only letters, numbers, spaces, hyphens, and periods are allowed';
